import { ExportButton } from './ExportButton'
import { withExportButton } from './withExportButton'

const ConnectedExportButton = withExportButton(ExportButton)

export { ConnectedExportButton as ExportButton }
